/**
 * 用户相关类型定义
 */

export enum UserRole {
  ADMIN = 'ADMIN',
  CUSTOMER = 'CUSTOMER',
  MARKET = 'MARKET',
  SERVICE = 'SERVICE',
  ENGINEER = 'ENGINEER',
  LAB_ENGINEER = 'LAB_ENGINEER',
  FINANCE = 'FINANCE',
  MONTHLY_ADMIN = 'MONTHLY_ADMIN',
}

export interface ImpersonationInfo {
  adminId: string
  impersonatedUserId: string
  sessionId: string
}
